<template>
  <v-tooltip bottom>
    <v-btn id="edit_edit_btn" :loading="loading" slot="activator" color="teal" outline @click="onClick" :disabled="disabled" style="padding-right: 10px;">
      Editar
      <v-icon style="padding-left: 10px;" color="teal">edit</v-icon>
    </v-btn>
    <span>{{tooltipText}}</span>
  </v-tooltip>
</template>

<script>
  export default {
    props: {
      loading: false,
      disabled: false,
      tooltipText: {
        default: 'Editar',
        type: String
      }
    },
    methods: {
      onClick () {
        this.$emit('onClick')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/shared/PEditBtn.vue